import { css } from 'lit';
import { hostReset } from '../styles/mixins.js';
import * as t from '../styles/tokens.js';

export default [
  hostReset,
  css`
    :host {
      display: inline-block;
      vertical-align: top;
    }
    :host([fluid]) { display: block; width: 100%; }

    /* ── Container ──────────────────────────────────────────────────────────── */
    .uwc-lb {
      --_radius:      var(--uwc-listbox-radius,     ${t.radiusMd});
      --_border:      var(--uwc-listbox-border,     1px solid ${t.borderControl});
      --_bg:          var(--uwc-listbox-bg,         ${t.surface});
      /* Derive the row height from the shared control-height token so listbox
         rows scale in lock-step with every other control (was a fixed 2.5rem
         that ignored the size/density scale). */
      --_item-height: var(--uwc-listbox-item-height, ${t.controlHeightMd});
      --_font-size:   var(--uwc-listbox-font-size,  ${t.fontSizeMd});
      --_color:       var(--uwc-listbox-color,      var(--uwc-color-primary, ${t.primary}));

      display: flex;
      flex-direction: column;
      width: 100%;
      background:    var(--_bg);
      border:        var(--_border);
      border-radius: var(--_radius);
      overflow: hidden;
      font-size: var(--_font-size);
    }

    /* ── Filter ─────────────────────────────────────────────────────────────── */
    .uwc-lb__filter {
      padding: ${t.space2};
      border-bottom: 1px solid ${t.borderSubtle};
    }

    /* ── List ───────────────────────────────────────────────────────────────── */
    .uwc-lb__list {
      list-style: none;
      margin: 0;
      padding: ${t.space1} 0;
      overflow-y: auto;
      max-height: var(--uwc-listbox-max-height, 14rem);
      outline: none;
    }

    /* ── Item ───────────────────────────────────────────────────────────────── */
    .uwc-lb__item {
      display: flex;
      align-items: center;
      gap: ${t.space2};
      min-height: var(--_item-height);
      padding: 0.375rem ${t.space3};
      cursor: pointer;
      transition: background-color ${t.durationFast};
      color: ${t.text};
    }
    .uwc-lb__item:hover           { background-color: ${t.hoverBg}; }
    .uwc-lb__item--selected       { background-color: ${t.selectedBg}; color: var(--_color); font-weight: ${t.fontWeightMedium}; }
    .uwc-lb__item--selected:hover { background-color: color-mix(in oklab, ${t.selectedBg} 120%, transparent); }
    .uwc-lb__item--disabled       { pointer-events: none; opacity: 0.5; }
    .uwc-lb__item--focused        { background-color: ${t.hoverBg}; }

    /* Check icon for single-select selected item */
    .uwc-lb__check {
      margin-inline-start: auto;
      flex-shrink: 0;
      display: none;
      color: var(--_color);
    }
    .uwc-lb__item--selected .uwc-lb__check { display: flex; }

    /* Badge */
    .uwc-lb__item-badge {
      margin-inline-start: auto;
      font-size: 0.7em;
      opacity: 0.7;
    }

    /* Label */
    .uwc-lb__item-label { flex: 1; min-width: 0; }

    /* ── Group header ───────────────────────────────────────────────────────── */
    .uwc-lb__group-header {
      display: flex;
      align-items: center;
      padding: 0.375rem ${t.space3};
      font-size: ${t.fontSizeSm};
      font-weight: ${t.fontWeightSemibold};
      color: ${t.textSecondary};
      text-transform: uppercase;
      letter-spacing: 0.04em;
    }

    /* ── Empty ──────────────────────────────────────────────────────────────── */
    .uwc-lb__empty {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: ${t.space6};
      color: ${t.textMuted};
      font-size: ${t.fontSizeSm};
    }

    /* ── Disabled host ──────────────────────────────────────────────────────── */
    :host([disabled]) .uwc-lb {
      pointer-events: none;
      opacity: 0.6;
    }

    /* ── Invalid ────────────────────────────────────────────────────────────── */
    :host([invalid]) .uwc-lb {
      border-color: var(--uwc-color-danger, ${t.danger});
    }
  `,
];
